import React from 'react';

import { getTextThemeProvider } from 'venn-ui-kit';

import { useRecoilValue } from 'recoil';
import { viewShowVenncast } from 'venn-state';
import { useHasFF } from 'venn-utils';
import { Block } from '../../core';

export const Venncast = ({ id }: { id: string }) => {
  const hasStudioVenncastFF = useHasFF('studio_venncast_ff');
  const showVenncast = useRecoilValue(viewShowVenncast(id)) && hasStudioVenncastFF;

  if (!showVenncast) {
    return null;
  }

  return (
    <Block.MetadataItem iconType="chart-line">
      {getTextThemeProvider().VenncastName} Missing Data: On
    </Block.MetadataItem>
  );
};
